import { RegistrationFieldType } from '../GraphQL/schema/types';

export const defaultFullNameField = {
  fieldName: 'Name',
  isRequired: true,
  type: RegistrationFieldType.Text,
  isRemovable: false,
  propertyName: 'name',
};

export const getAttendeeFieldValueFieldName = (index: number): string => {
  return index === 0
    ? 'firstName'
    : index === 1
      ? 'lastName'
      : index === 2
        ? 'email'
        : `attendeeFields.${index}.value`;
};

export const getAttendeeFieldName = (index: number): string => {
  return `attendeeFields.${index}`;
};

export const getFieldName = (index: number): string => {
  return `fields.${index}`;
};
